import { render, staticRenderFns } from "./YoutubeConfig.vue?vue&type=template&id=f69b5086&scoped=true&"
import script from "./YoutubeConfig.vue?vue&type=script&lang=js&"
export * from "./YoutubeConfig.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeConfig.vue?vue&type=style&index=0&id=f69b5086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69b5086",
  null
  
)

export default component.exports